import { render, staticRenderFns } from "./wanliu.vue?vue&type=template&id=eded8dc6&scoped=true&lang=pug&"
import script from "./wanliu.vue?vue&type=script&lang=js&"
export * from "./wanliu.vue?vue&type=script&lang=js&"
import style0 from "./wanliu.vue?vue&type=style&index=0&id=eded8dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eded8dc6",
  null
  
)

export default component.exports